import React, { useState, useEffect, useLayoutEffect, useRef, useContext } from 'react';
import CrmContactsTable from './CrmContactsTable';
import { store } from 'components/Store';
import RemoveContactsModal from './RemoveContactsModal/RemoveContactsModal';
import { useLocation, useNavigate, useParams } from 'react-router';
import RemoveContactTagsModal from './CrmContactsTable/CrmContactsListBar/RemoveContactTagsModal';
import ChampionStatusModal from './CrmContactsTable/CrmContactsListBar/ChampionStatusModal';
import CrmContactsFilters from './CrmContactsFilters';
import CrmContactsTableSkeleton from './CrmContactsTable/CrmContactsSkeleton';
import useIsMobile from 'components/Dashboard/utilities/useIsMobile';
import getAppSite from 'utils/getAppSite';

const CrmContacts = (props) => {
  const globalState = useContext(store);
  const { dispatch, state } = globalState;
  const {
    selectedCrmContacts,
    crmContactsTotalHits,
    showRemoveContactsModal,
    showRemoveContactTagsModal,
    showChangeChampionStatusModal,
  } = state;

  const { filters, groupPage } = props;

  const [mainLoading, setMainLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  const initialCall = useRef(null);

  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  const { groupId } = params;
  const isMobile = useIsMobile();

  const setShowAddTagsModal = (value) => {
    dispatch({
      type: 'MODIFY_SECTION',
      parameter: 'showAddTagsModalCrmContacts',
      value,
    });
  };

  const setSelectedCrmContacts = (value) => {
    dispatch({
      type: 'MODIFY_SECTION',
      parameter: 'selectedCrmContacts',
      value,
    });
  };

  const setTotalHits = (value) => {
    dispatch({
      type: 'MODIFY_SECTION',
      parameter: 'crmContactsTotalHits',
      value,
    });
  };

  const resetSelectedContacts = () => {
    setSelectedCrmContacts({
      selectedAll: false,
      selectedIds: [],
      selectedAllVisible: [],
    });
  };

  useEffect(() => {
    return () => {
      resetSelectedContacts();
    };
  }, []);

  useLayoutEffect(() => {
    const query = new URLSearchParams(location.search);
    const hasSort = query.get('sort');
    const hasSearch = query.get('search');

    if (!hasSort && !hasSearch) {
      query.set('sort', 'lastName_asc');
      if (getAppSite() === 'usa' && !query.has('includeStaff')) {
        query.set('includeStaff', 'true');
      }
      navigate(
        {
          pathname: location.pathname,
          search: query.toString(),
          hash: location.hash,
        },
        { replace: true, state: location.state }
      );
      return;
    }
    setMainLoading(false);
  }, [location.search, location.hash, location.pathname]);

  return (
    <>
      <RemoveContactsModal
        selectedCrmContacts={selectedCrmContacts}
        setSelectedCrmContacts={setSelectedCrmContacts}
        resetSelectedContacts={resetSelectedContacts}
        totalHits={crmContactsTotalHits}
        initialCall={initialCall}
        showRemoveContactsModal={showRemoveContactsModal}
      />
      <RemoveContactTagsModal
        totalHits={crmContactsTotalHits}
        showRemoveContactTagsModal={showRemoveContactTagsModal}
      />
      <div className={`main-content pl-md-4 pl-3 h-100 d-flex flex-column ${groupPage ? 'pt-4' : ''}`}>
        {!groupId && !isMobile && <CrmContactsFilters />}
        <div className='d-flex flex-column flex-grow-1'>
          {mainLoading ? (
            <div className={`row mx-0 h-100`}>
              <div className='flex-grow-1' style={{ overflow: 'hidden' }}>
                <CrmContactsTableSkeleton />
              </div>
            </div>
          ) : (
            <CrmContactsTable
              selectedCrmContacts={selectedCrmContacts}
              setSelectedCrmContacts={setSelectedCrmContacts}
              setTotalHits={setTotalHits}
              isLoadingState={{ isLoading, setIsLoading }}
              initialCall={initialCall}
              setShowAddTagsModal={setShowAddTagsModal}
              filters={filters}
            />
          )}
        </div>
      </div>
      <ChampionStatusModal
        isOpen={showChangeChampionStatusModal}
        totalHits={crmContactsTotalHits}
        setIsOpen={(value) => {
          dispatch({
            type: 'MODIFY_SECTION',
            parameter: 'showChangeChampionStatusModal',
            value,
          });
        }}
      />
    </>
  );
};

export default CrmContacts;
